import {fabric} from "fabric";

export default class MeasurementUI {
    store;
    canvas;

    rect;
    wrapper;
    listeners;

    _el_label_canvas_width;
    _el_label_canvas_height;

    constructor(store) {
        this.store = store;
        this.canvas = store.canvas;

        this.wrapper = $(`
        <div class="position-absolute pe-none fw-600 fs-3 measurement-ui">
            <div class="position-absolute d-flex justify-content-center" style="left: 0; right: 0">
                <div id="label_canvas_width" class="position-absolute" style="bottom: 10px; line-height: 15px">0</div>
            </div>
            <div class="position-absolute d-flex align-items-center" style="top: 0; bottom: 0">
                <div id="label_canvas_height" class="position-absolute" style="right: 10px; line-height: 15px">0</div>
            </div>
        </div>`
        );

        $('#canvas-wrapper').append(this.wrapper);
        this._el_label_canvas_width = $(this.wrapper).find(`#label_canvas_width`);
        this._el_label_canvas_height = $(this.wrapper).find(`#label_canvas_height`);

        this.update = this.update.bind(this);
        this.onResize = this.onResize.bind(this);
        this.listeners = {
            'viewport:pan': this.update,
            'viewport:zoom' : this.update,
            'canvas:resize' : this.onResize,
        }
        this.canvas.on(this.listeners);
        this.store.onDimensionsChanged(this.update);

        this.rect = new fabric.Rect();
        this.update();
    }

    update() {
        let zoom = this.canvas.getZoom();

        this.rect.set({
            width: 300 * Number(this.store.width),
            height: 300 * Number(this.store.height),
            originX: 'center',
            originY: 'center',
        })
        let cords = this.canvas.getAbsoluteCoords(this.rect);

        this.wrapper.css({
            'left': `${cords.left+1}px`,
            'top': `${cords.top+1}px`,
            'width': `${300 * Number(this.store.width) * zoom}px`,
            'height': `${300 * Number(this.store.height) * zoom}px`,
        });

        this._el_label_canvas_width.html(`${this.store.width}”`);
        this._el_label_canvas_height.html(`${this.store.height}”`);

        $('.measurement-ui').show();
    }

    clearRender() {
        $('.measurement-ui').hide();
    }

    onResize() {
        this.clearRender();

        let app = this;
        setTimeout(()=> {
            app.update();
        }, 0);
    }
}
